import { BaseModal } from "./BaseModal";

export function MobileClearModal({ isOpen, onClose, onClearToday, onClearAll, todayName }) {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title="Clear Meals"
      subtitle="What would you like to clear?"
    >
      <div className="space-y-2">
        <button
          onClick={() => { onClearToday(); onClose(); }}
          className="w-full px-4 py-3 text-sm font-medium text-left text-red-600 border border-red-200 rounded-lg hover:bg-red-50 transition-colors"
        >
          <div className="font-medium">Clear {todayName}</div>
          <div className="text-xs text-red-400 mt-0.5">Remove all meals planned for today</div>
        </button>
        <button
          onClick={() => { onClearAll(); onClose(); }}
          className="w-full px-4 py-3 text-sm font-medium text-left text-red-600 border border-red-200 rounded-lg hover:bg-red-50 transition-colors"
        >
          <div className="font-medium">Clear Entire Week</div>
          <div className="text-xs text-red-400 mt-0.5">Remove all meals from every day</div>
        </button>
        <button
          onClick={onClose}
          className="w-full px-4 py-3 text-sm font-medium text-gray-700 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
        >
          Cancel
        </button>
      </div>
    </BaseModal>
  );
}
